import { GridSize } from "../../../types/puzzle/GridSize";

export const CrackTheCodeGridSize: GridSize = {
    gridSize: 1,
    rowsCount: 0,
    columnsCount: 0,
};
